import { ControllerPaletteColor } from './__palette-color';

export enum ControllerCalendarPickerColor {
  BorderNormal = ControllerPaletteColor.Ngb800,
  DefaultFg = ControllerPaletteColor.Ngb900,
}
